import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Paper,
  Chip,
  Divider,
  IconButton,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StarIcon from '@mui/icons-material/Star';
import VerifiedIcon from '@mui/icons-material/Verified';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SecurityIcon from '@mui/icons-material/Security';

const DEFAULT_PRODUCTS_MAP = {
  1: { id: 1, name: 'Royal Silver Necklace', category: 'Necklaces', price: 12500, weight: '45g', purity: '925 Silver', image: 'https://images.pexels.com/photos/1454171/pexels-photo-1454171.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Elegant royal silver necklace with intricate traditional design. Handcrafted by skilled artisans using pure 925 silver.' },
  2: { id: 2, name: 'Temple Jhumka Earrings', category: 'Earrings', price: 4800, weight: '18g', purity: '925 Silver', image: 'https://images.pexels.com/photos/1232931/pexels-photo-1232931.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: true, description: 'Traditional temple jhumka earrings in pure silver. Perfect for weddings and festivals.' },
  3: { id: 3, name: 'Silver Toe Ring Set', category: 'Rings', price: 1200, weight: '8g', purity: '925 Silver', image: 'https://images.pexels.com/photos/2735970/pexels-photo-2735970.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: true, description: 'Beautiful silver toe ring set for brides. Delicate craftsmanship.' },
  4: { id: 4, name: 'Classic Silver Bangle', category: 'Bangles', price: 8500, weight: '35g', purity: '925 Silver', image: 'https://images.pexels.com/photos/177332/pexels-photo-177332.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Classic silver bangle with fine engraving. Timeless elegance for daily wear.' },
  5: { id: 5, name: 'Elegant Silver Chain', category: 'Chains', price: 3200, weight: '15g', purity: '925 Silver', image: 'https://images.pexels.com/photos/168927/pexels-photo-168927.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Lightweight elegant silver chain for daily wear. Pure 925 silver.' },
  6: { id: 6, name: 'Peacock Silver Pendant', category: 'Pendants', price: 2800, weight: '12g', purity: '925 Silver', image: 'https://images.pexels.com/photos/2849742/pexels-photo-2849742.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: true, description: 'Stunning peacock design pendant in pure silver. A masterpiece of traditional art.' },
  7: { id: 7, name: 'Silver Coin 10g', category: 'Coins & Bars', price: 950, weight: '10g', purity: '999 Silver', image: 'https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Pure silver coin, ideal for gifting and investment. 999 purity.' },
  8: { id: 8, name: 'Silver Pooja Plate', category: 'Pooja Items', price: 15000, weight: '100g', purity: '925 Silver', image: 'https://images.pexels.com/photos/2442893/pexels-photo-2442893.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Beautifully crafted silver pooja plate for auspicious occasions.' },
  9: { id: 9, name: 'Bridal Choker Necklace', category: 'Necklaces', price: 22000, weight: '65g', purity: '925 Silver', image: 'https://images.pexels.com/photos/691046/pexels-photo-691046.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: true, description: 'Stunning bridal choker necklace with stone work. Perfect for the bride.' },
  10: { id: 10, name: 'Stud Earrings Set', category: 'Earrings', price: 1800, weight: '6g', purity: '925 Silver', image: 'https://images.pexels.com/photos/371285/pexels-photo-371285.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: true, description: 'Minimalist silver stud earrings for everyday elegance.' },
  11: { id: 11, name: 'Antique Silver Ring', category: 'Rings', price: 2200, weight: '10g', purity: '925 Silver', image: 'https://images.pexels.com/photos/230290/pexels-photo-230290.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Vintage-style antique silver ring with detailed craftsmanship.' },
  12: { id: 12, name: 'Silver Kada Bangle', category: 'Bangles', price: 6500, weight: '28g', purity: '925 Silver', image: 'https://images.pexels.com/photos/3266700/pexels-photo-3266700.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Traditional silver kada bangle with intricate motifs.' },
  13: { id: 13, name: 'Silver Lakshmi Coin 20g', category: 'Coins & Bars', price: 1900, weight: '20g', purity: '999 Silver', image: 'https://images.pexels.com/photos/1191531/pexels-photo-1191531.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: true, description: 'Lakshmi embossed silver coin for Diwali gifting.' },
  14: { id: 14, name: 'Silver Hoop Earrings', category: 'Earrings', price: 3500, weight: '14g', purity: '925 Silver', image: 'https://images.pexels.com/photos/3641056/pexels-photo-3641056.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Modern silver hoop earrings, lightweight and stylish.' },
  15: { id: 15, name: 'Silver Mangalsutra Chain', category: 'Chains', price: 5500, weight: '20g', purity: '925 Silver', image: 'https://images.pexels.com/photos/1457801/pexels-photo-1457801.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: true, description: 'Silver mangalsutra chain with delicate pendant.' },
  16: { id: 16, name: 'Silver Diya Lamp', category: 'Pooja Items', price: 4500, weight: '40g', purity: '925 Silver', image: 'https://images.pexels.com/photos/248077/pexels-photo-248077.jpeg?auto=compress&cs=tinysrgb&w=800', is_new_arrival: false, description: 'Pure silver diya lamp for daily pooja rituals.' },
};

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`http://localhost:5000/api/products/${id}`);
        setProduct(response.data);
      } catch (error) {
        console.error('Using default product data');
        const fallback = DEFAULT_PRODUCTS_MAP[id] || DEFAULT_PRODUCTS_MAP[1];
        setProduct(fallback);
      }
    };
    fetchProduct();
  }, [id]);

  if (!product) {
    return (
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h5">Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: '#FBF9F7', minHeight: '100vh', py: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <Paper
                sx={{
                  p: 2,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  borderRadius: 2,
                  position: 'relative',
                }}
              >
                <Box
                  component="img"
                  src={product.image || 'https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=800'}
                  alt={product.name}
                  onError={(e) => { e.target.onerror = null; e.target.src = 'https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=800'; }}
                  sx={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: 2,
                  }}
                />
                <IconButton
                  sx={{
                    position: 'absolute',
                    top: 20,
                    right: 20,
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
                  onClick={() => setIsFavorite(!isFavorite)}
                >
                  {isFavorite ? (
                    <FavoriteIcon sx={{ color: '#D4AF37' }} />
                  ) : (
                    <FavoriteBorderIcon />
                  )}
                </IconButton>
              </Paper>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <Box>
                <Chip
                  label={product.category}
                  sx={{
                    backgroundColor: '#1B1464',
                    color: 'white',
                    fontWeight: 600,
                    mb: 2,
                  }}
                />
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    color: '#1A1A2E',
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                  }}
                >
                  {product.name}
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    {[...Array(5)].map((_, i) => (
                      <StarIcon key={i} sx={{ fontSize: 24, color: '#FFD700' }} />
                    ))}
                  </Box>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    (128 reviews)
                  </Typography>
                </Box>

                <Typography
                  variant="h4"
                  sx={{
                    color: '#1B1464',
                    fontWeight: 700,
                    mb: 3,
                    fontSize: { xs: '1.5rem', md: '2rem' },
                  }}
                >
                  ₹{product.price.toLocaleString()}
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Typography variant="body1" sx={{ mb: 3, color: '#666', lineHeight: 1.8 }}>
                  {product.description || 'Exquisite silver jewelry crafted with precision and care. Perfect for any occasion, this piece combines traditional craftsmanship with modern elegance.'}
                </Typography>

                <Box sx={{ mb: 3 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Paper sx={{ p: 2, textAlign: 'center', backgroundColor: '#F5F5F5' }}>
                        <Typography variant="caption" sx={{ color: '#666' }}>
                          Weight
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {product.weight}
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <Paper sx={{ p: 2, textAlign: 'center', backgroundColor: '#F5F5F5' }}>
                        <Typography variant="caption" sx={{ color: '#666' }}>
                          Purity
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {product.purity}
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 3 }}>
                  <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    startIcon={<ShoppingCartIcon />}
                    sx={{
                      backgroundColor: '#1B1464',
                      color: 'white',
                      py: 1.5,
                      fontSize: '1rem',
                      fontWeight: 600,
                      '&:hover': {
                        backgroundColor: '#0F0D3D',
                      },
                    }}
                  >
                    Add to Cart
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{
                      borderColor: '#D4AF37',
                      color: '#D4AF37',
                      py: 1.5,
                      px: 3,
                      '&:hover': {
                        borderColor: '#B8960C',
                        backgroundColor: 'rgba(212, 175, 55, 0.08)',
                      },
                    }}
                  >
                    Buy Now
                  </Button>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <VerifiedIcon sx={{ color: '#D4AF37', fontSize: 28 }} />
                    <Box>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Certified Purity
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        100% authentic silver with certification
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <LocalShippingIcon sx={{ color: '#D4AF37', fontSize: 28 }} />
                    <Box>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Free Shipping
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        On all orders above ₹5,000
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <SecurityIcon sx={{ color: '#D4AF37', fontSize: 28 }} />
                    <Box>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Secure Payment
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        100% secure and encrypted transactions
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </motion.div>
          </Grid>
        </Grid>

        <Box sx={{ mt: 6 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: '1.3rem', md: '2rem' } }}>
            Product Details
          </Typography>
          <Paper sx={{ p: { xs: 2, md: 4 }, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', borderRadius: 2 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Material:</strong> Pure Silver
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Purity:</strong> {product.purity}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Weight:</strong> {product.weight}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Category:</strong> {product.category}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Availability:</strong> In Stock
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>SKU:</strong> VVM-{product.id.toString().padStart(6, '0')}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default ProductDetail;
